/**
 * Business manifest for the MaviRoll Connect door.
 *
 * Generated by `pnpm cad:convert --manifest`, then enriched from the paper nomenclature
 * (`cad/nomenclature/maviroll-nomenclature.json`, transcribed from
 * NOMENCLATURE - MAVIROLL, indice B, 02/2023).
 *
 * `nodeName` comes from the GLB and must not be hand-edited: re-run
 *   pnpm cad:convert -- cad/source/maviroll-connect.stp cad/out/maviroll-connect.glb \
 *     --part-depth=2 --min-volume=0 --exclude="CARTE M230" --check-model=maviroll-connect
 *
 * 27 of 184 parts are tied to a nomenclature article: those carry a real
 * `reference` and an `article` number. The rest keep an explicit placeholder, because the
 * nomenclature supplied describes the MAVIROLL variant with soft guides and chain drive,
 * whereas this STEP is the MAVIROLL CONNECT variant with semi-rigid guides and belt drive.
 * See docs/rapport-cao-maviroll.md for the full cross-reference.
 *
 * `explodeVector`, `explodeDistance` and `fixed` are presentation choices and are safe to
 * adjust by hand.
 */

import {CadModelManifest} from '@shared/models/cad_model';

export const MAVIROLL_CONNECT_MANIFEST: CadModelManifest = {
  comment:
    'Enriched from the MAVIROLL paper nomenclature: 27/184 parts carry a real ' +
    'reference. Parts without one are absent from that nomenclature (different door variant).',
  parts: [
    {
      id: '1-capot-traverse',
      nodeName: '60009',
      label: 'capot traverse',
      reference: '60009',
      category: 'Structure',
      description:
        'Repere 1 de la nomenclature MAVIROLL. Capot traverse. Piece de fabrication Maviflex. Quantite nomenclature : 1.',
      explodeDistance: 1.0,
    },
    {
      id: '980497-voile-frein',
      nodeName: '980497_VOILE_FREIN',
      label: '980497 VOILE FREIN',
      reference: 'REF-A-COMPLETER',
      category: 'Motorisation',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: '980498-voile-moteur',
      nodeName: '980498_VOILE_MOTEUR',
      label: '980498 VOILE MOTEUR',
      reference: 'REF-A-COMPLETER',
      category: 'Motorisation',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: '980500-montage-tambour',
      nodeName: '980500_MONTAGE_TAMBOUR',
      label: '980500 MONTAGE TAMBOUR',
      reference: 'REF-A-COMPLETER',
      category: 'Motorisation',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'acv005832-entretoise-palier-maviroll-maviclean-c',
      nodeName: 'ACV005832_ENTRETOISE_PALIER_MAVIROLL_MAVICLEAN_CONNECT',
      label: 'ACV005832 ENTRETOISE PALIER MAVIROLL-MAVICLEAN CONNECT',
      reference: 'REF-A-COMPLETER',
      category: 'Motorisation',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: '980499-assemblage-moteur',
      nodeName: '980499_ASSEMBLAGE_MOTEUR',
      label: '980499 ASSEMBLAGE MOTEUR',
      reference: 'REF-A-COMPLETER',
      category: 'Motorisation',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'acv005835-courroie-d-entrainement-maviroll-mavic',
      nodeName: 'ACV005835_COURROIE_D_ENTRAINEMENT_MAVIROLL_MAVICLEAN',
      label: "ACV005835 COURROIE D' ENTRAINEMENT MAVIROLL-MAVICLEAN",
      reference: 'REF-A-COMPLETER',
      category: 'Motorisation',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'acv005831-support-aimant-maviroll-maviclean-conn',
      nodeName: 'ACV005831_SUPPORT_AIMANT_MAVIROLL_MAVICLEAN_CONNECT',
      label: 'ACV005831 SUPPORT + AIMANT MAVIROLL-MAVICLEAN CONNECT',
      reference: 'REF-A-COMPLETER',
      category: 'Securite',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'acv007015-fin-de-course-electronique',
      nodeName: 'ACV007015_FIN_DE_COURSE_ELECTRONIQUE',
      label: 'ACV007015 FIN DE COURSE ELECTRONIQUE',
      reference: 'REF-A-COMPLETER',
      category: 'Securite',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: '7-clavette-parallele-a-8x7x25-si-tambour-cote-mo',
      nodeName: 'clavette_parallele_A_8x7x25',
      label: 'clavette parallele-A-8x7x25 (SI TAMBOUR COTE MOTEUR D25)',
      reference: 'clavette parallele-A-8x7x25',
      category: 'Motorisation',
      description:
        'Repere 7 de la nomenclature MAVIROLL. Clavette parallele-a-8x7x25 (si tambour cote moteur d25). Code article epoxy : ACV004374. Quantite nomenclature : 1.',
      explodeDistance: 1.0,
    },
    {
      id: 'circlips-arbre-001',
      nodeName: 'Circlips_arbre_001',
      label: 'Circlips arbre 001',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: '22-capot-plastique-cote-fin-de-course',
      nodeName: '500423',
      label: 'capot plastique cote fin de course',
      reference: '500423',
      category: 'Structure',
      description:
        'Repere 22 de la nomenclature MAVIROLL. Capot plastique cote fin de course. Code article epoxy : ACV004284. Quantite nomenclature : 1.',
      explodeDistance: 1.0,
    },
    {
      id: '21-capot-plastique-cote-moteur',
      nodeName: '500422',
      label: 'capot plastique cote moteur',
      reference: '500422',
      category: 'Motorisation',
      description:
        'Repere 21 de la nomenclature MAVIROLL. Capot plastique cote moteur. Code article epoxy : ACV004285. Quantite nomenclature : 1.',
      explodeDistance: 1.0,
    },
    {
      id: '45-tube-rectangulaire',
      nodeName: '500026_A',
      label: 'tube rectangulaire',
      reference: '500026',
      category: 'Structure',
      description:
        'Repere 45 de la nomenclature MAVIROLL. Tube rectangulaire. Code article epoxy : ACV001426. Quantite nomenclature : 1.',
      explodeDistance: 1.0,
    },
    {
      id: '2-equerre-tube-rectangulaire',
      nodeName: '60010_ACV000615_EQUERRE_TUBE_RECTANGULAIRE',
      label: 'equerre tube rectangulaire',
      reference: '60010',
      category: 'Structure',
      description:
        'Repere 2 de la nomenclature MAVIROLL. Equerre tube rectangulaire. Code article epoxy : ACV000615. Quantite nomenclature : 3.',
      explodeDistance: 1.0,
    },
    {
      id: '2-equerre-tube-rectangulaire-2',
      nodeName: '60010_ACV000615_EQUERRE_TUBE_RECTANGULAIRE001',
      label: 'equerre tube rectangulaire',
      reference: '60010',
      category: 'Structure',
      description:
        'Repere 2 de la nomenclature MAVIROLL. Equerre tube rectangulaire. Code article epoxy : ACV000615. Quantite nomenclature : 3.',
      explodeDistance: 1.0,
    },
    {
      id: '2-equerre-tube-rectangulaire-3',
      nodeName: '60010_ACV000615_EQUERRE_TUBE_RECTANGULAIRE002',
      label: 'equerre tube rectangulaire',
      reference: '60010',
      category: 'Structure',
      description:
        'Repere 2 de la nomenclature MAVIROLL. Equerre tube rectangulaire. Code article epoxy : ACV000615. Quantite nomenclature : 3.',
      explodeDistance: 1.0,
    },
    {
      id: '24-cache-fin-de-course-gauche',
      nodeName: '500424_ACV004271_CACHE_FIN_DE_COURSE',
      label: 'cache fin de course gauche',
      reference: '500424',
      category: 'Structure',
      description:
        'Repere 24 de la nomenclature MAVIROLL. Cache fin de course gauche. Code article epoxy : ACV004271. Quantite nomenclature : 1.',
      explodeDistance: 1.0,
    },
    {
      id: '23-cache-moteur-droit',
      nodeName: '500425_ACV004269_CACHE_MOTEUR',
      label: 'cache moteur droit',
      reference: '500425',
      category: 'Motorisation',
      description:
        'Repere 23 de la nomenclature MAVIROLL. Cache moteur droit. Code article epoxy : ACV004269. Quantite nomenclature : 1.',
      explodeDistance: 1.0,
    },
    {
      id: '980496-assemblage-frein',
      nodeName: '980496_ASSEMBLAGE_FREIN',
      label: '980496 ASSEMBLAGE FREIN',
      reference: 'REF-A-COMPLETER',
      category: 'Motorisation',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: '3-rondelle-plate-z8',
      nodeName: 'rondelle_plate_Z_8x16',
      label: 'rondelle plate Z8',
      reference: 'rondelle plate Z-8x16',
      category: 'Visserie',
      description:
        'Repere 3 de la nomenclature MAVIROLL. Rondelle plate z8. Code article epoxy : ACV001177. Quantite nomenclature : 2.',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-plate-l-8x22',
      nodeName: 'rondelle_plate_L_8x22',
      label: 'rondelle plate L-8x22',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-h-autoforeuse6x25',
      nodeName: 'vis_H_autoforeuse6x25',
      label: 'vis H-autoforeuse6x25',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'acv006796-tambour-maviroll-maviclean-connect',
      nodeName: 'ACV006796_TAMBOUR_MAVIROLL_MAVICLEAN_CONNECT',
      label: 'ACV006796 TAMBOUR MAVIROLL-MAVICLEAN CONNECT',
      reference: 'REF-A-COMPLETER',
      category: 'Motorisation',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'ecrou-a-encoche-km05',
      nodeName: 'ecrou_a_encoche_KM05',
      label: 'ecrou a encoche KM05',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-de-securite-mb05',
      nodeName: 'Rondelle_de_securite_MB05',
      label: 'Rondelle de securite MB05',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'acv007411-bague-poulie-inox-3mm',
      nodeName: 'ACV007411_BAGUE_POULIE_INOX_3MM',
      label: 'ACV007411 BAGUE POULIE INOX 3MM',
      reference: 'REF-A-COMPLETER',
      category: 'Motorisation',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'acv007410-poulie-aluminium-ecrou-maviroll-mavicl',
      nodeName: 'ACV007410_POULIE_ALUMINIUM_ECROU_MAVIROLL_MAVICLEAN_CONNECT',
      label: 'ACV007410 POULIE ALUMINIUM ECROU MAVIROLL MAVICLEAN CONNECT',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: '500517-acv004421-equerre-voile',
      nodeName: '500517_ACV004421_EQUERRE_VOILE',
      label: '500517-ACV004421 EQUERRE VOILE',
      reference: 'REF-A-COMPLETER',
      category: 'Structure',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: '500517-acv004421-equerre-voile001',
      nodeName: '500517_ACV004421_EQUERRE_VOILE001',
      label: '500517-ACV004421 EQUERRE VOILE001',
      reference: 'REF-A-COMPLETER',
      category: 'Structure',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'acv005847-montant-droit-coulisse-semi-rigide-mav',
      nodeName: 'ACV005847_MONTANT_DROIT_COULISSE_SEMI_RIGIDE_MAVIROLL_CONNECT_AI',
      label: 'ACV005847 MONTANT DROIT  COULISSE SEMI RIGIDE MAVIROLL CONNECT AI',
      reference: 'REF-A-COMPLETER',
      category: 'Structure',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeVector: [1, 0, 0],
      explodeDistance: 1.0,
    },
    {
      id: 'acv005850-capot-montant-droit-coulisse-semi-rigi',
      nodeName: 'ACV005850_CAPOT_MONTANT_DROIT_COULISSE_SEMI_RIGIDE_MAVIROLL_CONNECT',
      label: 'ACV005850 CAPOT MONTANT DROIT COULISSE SEMI RIGIDE MAVIROLL CONNECT',
      reference: 'REF-A-COMPLETER',
      category: 'Structure',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeVector: [1, 0, 0],
      explodeDistance: 1.0,
    },
    {
      id: '500815',
      nodeName: '500815',
      label: '500815',
      reference: 'REF-A-COMPLETER',
      category: 'A-COMPLETER',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'acv005746-ecarteur-coulisse-semi-rigide',
      nodeName: 'ACV005746_ECARTEUR_COULISSE_SEMI_RIGIDE',
      label: 'ACV005746 ECARTEUR COULISSE SEMI RIGIDE',
      reference: 'REF-A-COMPLETER',
      category: 'Armoire electrique',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'acv004354-support-cellule',
      nodeName: 'ACV004354_SUPPORT_CELLULE',
      label: 'ACV004354 SUPPORT CELLULE',
      reference: 'REF-A-COMPLETER',
      category: 'Securite',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.0,
    },
    {
      id: 'acv004354-support-cellule001',
      nodeName: 'ACV004354_SUPPORT_CELLULE001',
      label: 'ACV004354 SUPPORT CELLULE001',
      reference: 'REF-A-COMPLETER',
      category: 'Securite',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.0,
    },
    {
      id: 'acv004354-support-cellule002',
      nodeName: 'ACV004354_SUPPORT_CELLULE002',
      label: 'ACV004354 SUPPORT CELLULE002',
      reference: 'REF-A-COMPLETER',
      category: 'Securite',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.0,
    },
    {
      id: 'acv005840-pied-de-montant-maviroll-connect',
      nodeName: 'ACV005840_PIED_DE_MONTANT_MAVIROLL_CONNECT',
      label: 'ACV005840 PIED DE MONTANT MAVIROLL CONNECT',
      reference: 'REF-A-COMPLETER',
      category: 'Structure',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'platine-armoire-integree-ip40-maviroll-m230',
      nodeName: 'PLATINE_ARMOIRE_INTEGREE_IP40_MAVIROLL_M230',
      label: 'PLATINE ARMOIRE INTEGREE IP40 - MAVIROLL M230',
      reference: 'REF-A-COMPLETER',
      category: 'Armoire electrique',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'vis-trcc-m6x16-inox',
      nodeName: 'vis_TRCC_M6X16_inox',
      label: 'vis TRCC -M6X16 inox',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn',
      nodeName: 'Ecrou_HM6_tollok_zn',
      label: 'Ecrou HM6 tollok zn',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox001',
      nodeName: 'vis_TRCC_M6X16_inox001',
      label: 'vis TRCC -M6X16 inox001',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn001',
      nodeName: 'Ecrou_HM6_tollok_zn001',
      label: 'Ecrou HM6 tollok zn001',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox002',
      nodeName: 'vis_TRCC_M6X16_inox002',
      label: 'vis TRCC -M6X16 inox002',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn002',
      nodeName: 'Ecrou_HM6_tollok_zn002',
      label: 'Ecrou HM6 tollok zn002',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox003',
      nodeName: 'vis_TRCC_M6X16_inox003',
      label: 'vis TRCC -M6X16 inox003',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn003',
      nodeName: 'Ecrou_HM6_tollok_zn003',
      label: 'Ecrou HM6 tollok zn003',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox004',
      nodeName: 'vis_TRCC_M6X16_inox004',
      label: 'vis TRCC -M6X16 inox004',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn004',
      nodeName: 'Ecrou_HM6_tollok_zn004',
      label: 'Ecrou HM6 tollok zn004',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn005',
      nodeName: 'Ecrou_HM6_tollok_zn005',
      label: 'Ecrou HM6 tollok zn005',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn006',
      nodeName: 'Ecrou_HM6_tollok_zn006',
      label: 'Ecrou HM6 tollok zn006',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox005',
      nodeName: 'vis_TRCC_M6X16_inox005',
      label: 'vis TRCC -M6X16 inox005',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox006',
      nodeName: 'vis_TRCC_M6X16_inox006',
      label: 'vis TRCC -M6X16 inox006',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox007',
      nodeName: 'vis_TRCC_M6X16_inox007',
      label: 'vis TRCC -M6X16 inox007',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox008',
      nodeName: 'vis_TRCC_M6X16_inox008',
      label: 'vis TRCC -M6X16 inox008',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox009',
      nodeName: 'vis_TRCC_M6X16_inox009',
      label: 'vis TRCC -M6X16 inox009',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox010',
      nodeName: 'vis_TRCC_M6X16_inox010',
      label: 'vis TRCC -M6X16 inox010',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox011',
      nodeName: 'vis_TRCC_M6X16_inox011',
      label: 'vis TRCC -M6X16 inox011',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox012',
      nodeName: 'vis_TRCC_M6X16_inox012',
      label: 'vis TRCC -M6X16 inox012',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn007',
      nodeName: 'Ecrou_HM6_tollok_zn007',
      label: 'Ecrou HM6 tollok zn007',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn008',
      nodeName: 'Ecrou_HM6_tollok_zn008',
      label: 'Ecrou HM6 tollok zn008',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn009',
      nodeName: 'Ecrou_HM6_tollok_zn009',
      label: 'Ecrou HM6 tollok zn009',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn010',
      nodeName: 'Ecrou_HM6_tollok_zn010',
      label: 'Ecrou HM6 tollok zn010',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn011',
      nodeName: 'Ecrou_HM6_tollok_zn011',
      label: 'Ecrou HM6 tollok zn011',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn012',
      nodeName: 'Ecrou_HM6_tollok_zn012',
      label: 'Ecrou HM6 tollok zn012',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'insert-acm6ftt-z-far004',
      nodeName: 'INSERT_ACM6FTT_Z_FAR004',
      label: 'INSERT ACM6FTT-Z-FAR004',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'insert-acm6ftt-z-far005',
      nodeName: 'INSERT_ACM6FTT_Z_FAR005',
      label: 'INSERT ACM6FTT-Z-FAR005',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'insert-acm6ftt-z-far006',
      nodeName: 'INSERT_ACM6FTT_Z_FAR006',
      label: 'INSERT ACM6FTT-Z-FAR006',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'insert-acm6ftt-z-far007',
      nodeName: 'INSERT_ACM6FTT_Z_FAR007',
      label: 'INSERT ACM6FTT-Z-FAR007',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'insert-acm6ftt-z-far008',
      nodeName: 'INSERT_ACM6FTT_Z_FAR008',
      label: 'INSERT ACM6FTT-Z-FAR008',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'insert-acm6ftt-z-far009',
      nodeName: 'INSERT_ACM6FTT_Z_FAR009',
      label: 'INSERT ACM6FTT-Z-FAR009',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-h-m6-25-zn',
      nodeName: 'vis_H_M6_25_zn',
      label: 'vis H-M6-25 zn',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-h-m6-25-zn001',
      nodeName: 'vis_H_M6_25_zn001',
      label: 'vis H-M6-25 zn001',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-h-m6-25-zn002',
      nodeName: 'vis_H_M6_25_zn002',
      label: 'vis H-M6-25 zn002',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-h-m6-25-zn003',
      nodeName: 'vis_H_M6_25_zn003',
      label: 'vis H-M6-25 zn003',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-h-m6-25-zn004',
      nodeName: 'vis_H_M6_25_zn004',
      label: 'vis H-M6-25 zn004',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-h-m6-25-zn005',
      nodeName: 'vis_H_M6_25_zn005',
      label: 'vis H-M6-25 zn005',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-plate-l-6x18',
      nodeName: 'rondelle_plate_L_6x18',
      label: 'rondelle plate L-6x18',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-plate-l-6x001',
      nodeName: 'rondelle_plate_L_6x001',
      label: 'rondelle plate L-6x001',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-plate-l-6x002',
      nodeName: 'rondelle_plate_L_6x002',
      label: 'rondelle plate L-6x002',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-plate-l-6x003',
      nodeName: 'rondelle_plate_L_6x003',
      label: 'rondelle plate L-6x003',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-plate-l-6x004',
      nodeName: 'rondelle_plate_L_6x004',
      label: 'rondelle plate L-6x004',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-plate-l-6x005',
      nodeName: 'rondelle_plate_L_6x005',
      label: 'rondelle plate L-6x005',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-tete-fraisee-m6x25',
      nodeName: 'vis_tete_fraisee_M6x25',
      label: 'vis tête fraisée M6x25',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn013',
      nodeName: 'Ecrou_HM6_tollok_zn013',
      label: 'Ecrou HM6 tollok zn013',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm8-tollok-zn',
      nodeName: 'Ecrou_HM8_tollok_zn',
      label: 'Ecrou HM8 tollok zn',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm8-tollok-zn001',
      nodeName: 'Ecrou_HM8_tollok_zn001',
      label: 'Ecrou HM8 tollok zn001',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm8-tollok-zn002',
      nodeName: 'Ecrou_HM8_tollok_zn002',
      label: 'Ecrou HM8 tollok zn002',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m8x20-inox',
      nodeName: 'vis_TRCC_M8X20_inox',
      label: 'vis TRCC -M8X20 - inox',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m8x20-inox001',
      nodeName: 'vis_TRCC_M8X20_inox001',
      label: 'vis TRCC -M8X20 - inox001',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m8x20-inox002',
      nodeName: 'vis_TRCC_M8X20_inox002',
      label: 'vis TRCC -M8X20 - inox002',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'acv005120',
      nodeName: 'ACV005120',
      label: 'ACV005120',
      reference: 'REF-A-COMPLETER',
      category: 'A-COMPLETER',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'acv006078',
      nodeName: 'ACV006078',
      label: 'ACV006078',
      reference: 'REF-A-COMPLETER',
      category: 'A-COMPLETER',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'ecran-carte',
      nodeName: 'ECRAN_CARTE',
      label: 'ECRAN CARTE',
      reference: 'REF-A-COMPLETER',
      category: 'Armoire electrique',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'acv006049-support-ecran-carte-connect',
      nodeName: 'ACV006049_support_ecran_carte_connect',
      label: 'ACV006049 support ecran carte connect',
      reference: 'REF-A-COMPLETER',
      category: 'Armoire electrique',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: '42-cellule-receptrice-pb-10',
      nodeName: 'CELLULE_ER_PB_10',
      label: 'cellule receptrice PB-10',
      reference: 'CELLULE ER PB-10',
      category: 'Securite',
      description:
        'Repere 42 de la nomenclature MAVIROLL. Cellule receptrice pb-10. Code article epoxy : ACV003392. Quantite nomenclature : 3 jeux.',
      explodeDistance: 2.0,
    },
    {
      id: 'ecrou-cellule',
      nodeName: 'Ecrou_CELLULE',
      label: 'Ecrou CELLULE',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-cellule001',
      nodeName: 'Ecrou_CELLULE001',
      label: 'Ecrou CELLULE001',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: '41-cellule-emettrice-pb-10',
      nodeName: 'CELLULE_EM_PB_10',
      label: 'cellule emettrice PB-10',
      reference: 'CELLULE EM PB-10',
      category: 'Securite',
      description:
        'Repere 41 de la nomenclature MAVIROLL. Cellule emettrice pb-10. Code article epoxy : ACV003391. Quantite nomenclature : 3 jeux.',
      explodeDistance: 2.0,
    },
    {
      id: 'ecrou-cellule002',
      nodeName: 'Ecrou_CELLULE002',
      label: 'Ecrou CELLULE002',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-cellule003',
      nodeName: 'Ecrou_CELLULE003',
      label: 'Ecrou CELLULE003',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: '42-cellule-receptrice-pb-10-2',
      nodeName: 'CELLULE_ER_PB_001',
      label: 'cellule receptrice PB-10',
      reference: 'CELLULE ER PB-10',
      category: 'Securite',
      description:
        'Repere 42 de la nomenclature MAVIROLL. Cellule receptrice pb-10. Code article epoxy : ACV003392. Quantite nomenclature : 3 jeux.',
      explodeDistance: 2.0,
    },
    {
      id: 'ecrou-cellule004',
      nodeName: 'Ecrou_CELLULE004',
      label: 'Ecrou CELLULE004',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-cellule005',
      nodeName: 'Ecrou_CELLULE005',
      label: 'Ecrou CELLULE005',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'acv005849-capot-montant-gauche-coulisse-semi-rig',
      nodeName: 'ACV005849_CAPOT_MONTANT_GAUCHE_COULISSE_SEMI_RIGIDE_MAVIROLL_CONNECT',
      label: 'ACV005849 CAPOT MONTANT GAUCHE COULISSE SEMI RIGIDE MAVIROLL CONNECT',
      reference: 'REF-A-COMPLETER',
      category: 'Structure',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeVector: [-1, 0, 0],
      explodeDistance: 1.0,
    },
    {
      id: '500816',
      nodeName: '500816',
      label: '500816',
      reference: 'REF-A-COMPLETER',
      category: 'A-COMPLETER',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'acv005746-ecarteur-coulisse-semi-rigide001',
      nodeName: 'ACV005746_ECARTEUR_COULISSE_SEMI_RIGIDE001',
      label: 'ACV005746 ECARTEUR COULISSE SEMI RIGIDE001',
      reference: 'REF-A-COMPLETER',
      category: 'Armoire electrique',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'acv004354-support-cellule003',
      nodeName: 'ACV004354_SUPPORT_CELLULE003',
      label: 'ACV004354 SUPPORT CELLULE003',
      reference: 'REF-A-COMPLETER',
      category: 'Securite',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.0,
    },
    {
      id: 'acv004354-support-cellule004',
      nodeName: 'ACV004354_SUPPORT_CELLULE004',
      label: 'ACV004354 SUPPORT CELLULE004',
      reference: 'REF-A-COMPLETER',
      category: 'Securite',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.0,
    },
    {
      id: 'acv004354-support-cellule005',
      nodeName: 'ACV004354_SUPPORT_CELLULE005',
      label: 'ACV004354 SUPPORT CELLULE005',
      reference: 'REF-A-COMPLETER',
      category: 'Securite',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.0,
    },
    {
      id: 'acv005840-pied-de-montant-maviroll-connect001',
      nodeName: 'ACV005840_PIED_DE_MONTANT_MAVIROLL_CONNECT001',
      label: 'ACV005840 PIED DE MONTANT MAVIROLL CONNECT001',
      reference: 'REF-A-COMPLETER',
      category: 'Structure',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'ecrou-hm6-tollok-zn014',
      nodeName: 'Ecrou_HM6_tollok_zn014',
      label: 'Ecrou HM6 tollok zn014',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox013',
      nodeName: 'vis_TRCC_M6X16_inox013',
      label: 'vis TRCC -M6X16 inox013',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn015',
      nodeName: 'Ecrou_HM6_tollok_zn015',
      label: 'Ecrou HM6 tollok zn015',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox014',
      nodeName: 'vis_TRCC_M6X16_inox014',
      label: 'vis TRCC -M6X16 inox014',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn016',
      nodeName: 'Ecrou_HM6_tollok_zn016',
      label: 'Ecrou HM6 tollok zn016',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox015',
      nodeName: 'vis_TRCC_M6X16_inox015',
      label: 'vis TRCC -M6X16 inox015',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn017',
      nodeName: 'Ecrou_HM6_tollok_zn017',
      label: 'Ecrou HM6 tollok zn017',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox016',
      nodeName: 'vis_TRCC_M6X16_inox016',
      label: 'vis TRCC -M6X16 inox016',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn018',
      nodeName: 'Ecrou_HM6_tollok_zn018',
      label: 'Ecrou HM6 tollok zn018',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox017',
      nodeName: 'vis_TRCC_M6X16_inox017',
      label: 'vis TRCC -M6X16 inox017',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox018',
      nodeName: 'vis_TRCC_M6X16_inox018',
      label: 'vis TRCC -M6X16 inox018',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox019',
      nodeName: 'vis_TRCC_M6X16_inox019',
      label: 'vis TRCC -M6X16 inox019',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn019',
      nodeName: 'Ecrou_HM6_tollok_zn019',
      label: 'Ecrou HM6 tollok zn019',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn020',
      nodeName: 'Ecrou_HM6_tollok_zn020',
      label: 'Ecrou HM6 tollok zn020',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox020',
      nodeName: 'vis_TRCC_M6X16_inox020',
      label: 'vis TRCC -M6X16 inox020',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox021',
      nodeName: 'vis_TRCC_M6X16_inox021',
      label: 'vis TRCC -M6X16 inox021',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox022',
      nodeName: 'vis_TRCC_M6X16_inox022',
      label: 'vis TRCC -M6X16 inox022',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox023',
      nodeName: 'vis_TRCC_M6X16_inox023',
      label: 'vis TRCC -M6X16 inox023',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox024',
      nodeName: 'vis_TRCC_M6X16_inox024',
      label: 'vis TRCC -M6X16 inox024',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m6x16-inox025',
      nodeName: 'vis_TRCC_M6X16_inox025',
      label: 'vis TRCC -M6X16 inox025',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn021',
      nodeName: 'Ecrou_HM6_tollok_zn021',
      label: 'Ecrou HM6 tollok zn021',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn022',
      nodeName: 'Ecrou_HM6_tollok_zn022',
      label: 'Ecrou HM6 tollok zn022',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn023',
      nodeName: 'Ecrou_HM6_tollok_zn023',
      label: 'Ecrou HM6 tollok zn023',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn024',
      nodeName: 'Ecrou_HM6_tollok_zn024',
      label: 'Ecrou HM6 tollok zn024',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn025',
      nodeName: 'Ecrou_HM6_tollok_zn025',
      label: 'Ecrou HM6 tollok zn025',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn026',
      nodeName: 'Ecrou_HM6_tollok_zn026',
      label: 'Ecrou HM6 tollok zn026',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'insert-acm6ftt-z-far010',
      nodeName: 'INSERT_ACM6FTT_Z_FAR010',
      label: 'INSERT ACM6FTT-Z-FAR010',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'insert-acm6ftt-z-far011',
      nodeName: 'INSERT_ACM6FTT_Z_FAR011',
      label: 'INSERT ACM6FTT-Z-FAR011',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'insert-acm6ftt-z-far012',
      nodeName: 'INSERT_ACM6FTT_Z_FAR012',
      label: 'INSERT ACM6FTT-Z-FAR012',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'insert-acm6ftt-z-far013',
      nodeName: 'INSERT_ACM6FTT_Z_FAR013',
      label: 'INSERT ACM6FTT-Z-FAR013',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'insert-acm6ftt-z-far014',
      nodeName: 'INSERT_ACM6FTT_Z_FAR014',
      label: 'INSERT ACM6FTT-Z-FAR014',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'insert-acm6ftt-z-far015',
      nodeName: 'INSERT_ACM6FTT_Z_FAR015',
      label: 'INSERT ACM6FTT-Z-FAR015',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-plate-l-6x006',
      nodeName: 'rondelle_plate_L_6x006',
      label: 'rondelle plate L-6x006',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-plate-l-6x007',
      nodeName: 'rondelle_plate_L_6x007',
      label: 'rondelle plate L-6x007',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-plate-l-6x008',
      nodeName: 'rondelle_plate_L_6x008',
      label: 'rondelle plate L-6x008',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-plate-l-6x009',
      nodeName: 'rondelle_plate_L_6x009',
      label: 'rondelle plate L-6x009',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-plate-l-6x010',
      nodeName: 'rondelle_plate_L_6x010',
      label: 'rondelle plate L-6x010',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'rondelle-plate-l-6x011',
      nodeName: 'rondelle_plate_L_6x011',
      label: 'rondelle plate L-6x011',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-h-m6-25-zn006',
      nodeName: 'vis_H_M6_25_zn006',
      label: 'vis H-M6-25 zn006',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-h-m6-25-zn007',
      nodeName: 'vis_H_M6_25_zn007',
      label: 'vis H-M6-25 zn007',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-h-m6-25-zn008',
      nodeName: 'vis_H_M6_25_zn008',
      label: 'vis H-M6-25 zn008',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-h-m6-25-zn009',
      nodeName: 'vis_H_M6_25_zn009',
      label: 'vis H-M6-25 zn009',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-h-m6-25-zn010',
      nodeName: 'vis_H_M6_25_zn010',
      label: 'vis H-M6-25 zn010',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-h-m6-25-zn011',
      nodeName: 'vis_H_M6_25_zn011',
      label: 'vis H-M6-25 zn011',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-tete-fraisee-m6x001',
      nodeName: 'vis_tete_fraisee_M6x001',
      label: 'vis tête fraisée M6x001',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm6-tollok-zn027',
      nodeName: 'Ecrou_HM6_tollok_zn027',
      label: 'Ecrou HM6 tollok zn027',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m8x20-inox003',
      nodeName: 'vis_TRCC_M8X20_inox003',
      label: 'vis TRCC -M8X20 - inox003',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m8x20-inox004',
      nodeName: 'vis_TRCC_M8X20_inox004',
      label: 'vis TRCC -M8X20 - inox004',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'vis-trcc-m8x20-inox005',
      nodeName: 'vis_TRCC_M8X20_inox005',
      label: 'vis TRCC -M8X20 - inox005',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm8-tollok-zn003',
      nodeName: 'Ecrou_HM8_tollok_zn003',
      label: 'Ecrou HM8 tollok zn003',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm8-tollok-zn004',
      nodeName: 'Ecrou_HM8_tollok_zn004',
      label: 'Ecrou HM8 tollok zn004',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: 'ecrou-hm8-tollok-zn005',
      nodeName: 'Ecrou_HM8_tollok_zn005',
      label: 'Ecrou HM8 tollok zn005',
      reference: 'REF-A-COMPLETER',
      category: 'Visserie',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 2.4,
    },
    {
      id: '10-clavier-sensitif',
      nodeName: 'clavier_sensitif',
      label: 'clavier sensitif',
      reference: 'clavier sensitif',
      category: 'Securite',
      description:
        'Repere 10 de la nomenclature MAVIROLL. Clavier sensitif. Code article epoxy : ACV000688. Quantite nomenclature : 1.',
      explodeDistance: 1.0,
    },
    {
      id: '10-clavier-sensitif-2',
      nodeName: 'clavier_sensitif001',
      label: 'clavier sensitif',
      reference: 'clavier sensitif',
      category: 'Securite',
      description:
        'Repere 10 de la nomenclature MAVIROLL. Clavier sensitif. Code article epoxy : ACV000688. Quantite nomenclature : 1.',
      explodeDistance: 1.0,
    },
    {
      id: '46-feux-lunax-24vac',
      nodeName: '3017_ETM',
      label: 'FEUX LUNAX 24Vac',
      reference: 'FEUX LUNAX 24Vac',
      category: 'Securite',
      description:
        'Repere 46 de la nomenclature MAVIROLL. Feux lunax 24vac. Code article epoxy : ACV000682. Quantite nomenclature : 2.',
      explodeDistance: 1.0,
    },
    {
      id: '46-feux-lunax-24vac-2',
      nodeName: '3017_ETM001',
      label: 'FEUX LUNAX 24Vac',
      reference: 'FEUX LUNAX 24Vac',
      category: 'Securite',
      description:
        'Repere 46 de la nomenclature MAVIROLL. Feux lunax 24vac. Code article epoxy : ACV000682. Quantite nomenclature : 2.',
      explodeDistance: 1.0,
    },
    {
      id: 'coffret-abs-400-x-300-x-190',
      nodeName: 'COFFRET_ABS_400_X_300_X_190',
      label: 'COFFRET ABS 400 X 300 X 190',
      reference: 'REF-A-COMPLETER',
      category: 'Armoire electrique',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: '41-cellule-emettrice-pb-10-2',
      nodeName: 'CELLULE_EM_PB_001',
      label: 'cellule emettrice PB-10',
      reference: 'CELLULE EM PB-10',
      category: 'Securite',
      description:
        'Repere 41 de la nomenclature MAVIROLL. Cellule emettrice pb-10. Code article epoxy : ACV003391. Quantite nomenclature : 3 jeux.',
      explodeDistance: 2.0,
    },
    {
      id: '41-cellule-emettrice-pb-10-3',
      nodeName: 'CELLULE_EM_PB_002',
      label: 'cellule emettrice PB-10',
      reference: 'CELLULE EM PB-10',
      category: 'Securite',
      description:
        'Repere 41 de la nomenclature MAVIROLL. Cellule emettrice pb-10. Code article epoxy : ACV003391. Quantite nomenclature : 3 jeux.',
      explodeDistance: 2.0,
    },
    {
      id: '41-cellule-emettrice-pb-10-4',
      nodeName: 'CELLULE_EM_PB_003',
      label: 'cellule emettrice PB-10',
      reference: 'CELLULE EM PB-10',
      category: 'Securite',
      description:
        'Repere 41 de la nomenclature MAVIROLL. Cellule emettrice pb-10. Code article epoxy : ACV003391. Quantite nomenclature : 3 jeux.',
      explodeDistance: 2.0,
    },
    {
      id: '42-cellule-receptrice-pb-10-3',
      nodeName: 'CELLULE_ER_PB_002',
      label: 'cellule receptrice PB-10',
      reference: 'CELLULE ER PB-10',
      category: 'Securite',
      description:
        'Repere 42 de la nomenclature MAVIROLL. Cellule receptrice pb-10. Code article epoxy : ACV003392. Quantite nomenclature : 3 jeux.',
      explodeDistance: 2.0,
    },
    {
      id: '42-cellule-receptrice-pb-10-4',
      nodeName: 'CELLULE_ER_PB_003',
      label: 'cellule receptrice PB-10',
      reference: 'CELLULE ER PB-10',
      category: 'Securite',
      description:
        'Repere 42 de la nomenclature MAVIROLL. Cellule receptrice pb-10. Code article epoxy : ACV003392. Quantite nomenclature : 3 jeux.',
      explodeDistance: 2.0,
    },
    {
      id: '42-cellule-receptrice-pb-10-5',
      nodeName: 'CELLULE_ER_PB_004',
      label: 'cellule receptrice PB-10',
      reference: 'CELLULE ER PB-10',
      category: 'Securite',
      description:
        'Repere 42 de la nomenclature MAVIROLL. Cellule receptrice pb-10. Code article epoxy : ACV003392. Quantite nomenclature : 3 jeux.',
      explodeDistance: 2.0,
    },
    {
      id: '7-clavette-parallele-a-8x7x25-si-tambour-cote-mo-2',
      nodeName: 'clavette_parallele_A_8x7x001',
      label: 'clavette parallele-A-8x7x25 (SI TAMBOUR COTE MOTEUR D25)',
      reference: 'clavette parallele-A-8x7x25',
      category: 'Motorisation',
      description:
        'Repere 7 de la nomenclature MAVIROLL. Clavette parallele-a-8x7x25 (si tambour cote moteur d25). Code article epoxy : ACV004374. Quantite nomenclature : 1.',
      explodeDistance: 1.0,
    },
    {
      id: '7-clavette-parallele-a-8x7x25-si-tambour-cote-mo-3',
      nodeName: 'clavette_parallele_A_8x7x002',
      label: 'clavette parallele-A-8x7x25 (SI TAMBOUR COTE MOTEUR D25)',
      reference: 'clavette parallele-A-8x7x25',
      category: 'Motorisation',
      description:
        'Repere 7 de la nomenclature MAVIROLL. Clavette parallele-a-8x7x25 (si tambour cote moteur d25). Code article epoxy : ACV004374. Quantite nomenclature : 1.',
      explodeDistance: 1.0,
    },
    {
      id: 'acv006061-toile-maviroll-connect-simple-peau-san',
      nodeName: 'ACV006061_TOILE_MAVIROLL_CONNECT_SIMPLE_PEAU_SANS_PROFIL',
      label: 'ACV006061 TOILE MAVIROLL CONNECT SIMPLE PEAU SANS PROFIL',
      reference: 'REF-A-COMPLETER',
      category: 'Tablier',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
      fixed: true,
    },
    {
      id: 'acv001405',
      nodeName: 'ACV001405',
      label: 'ACV001405--',
      reference: 'REF-A-COMPLETER',
      category: 'A-COMPLETER',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: '500817',
      nodeName: '500817',
      label: '500817',
      reference: 'REF-A-COMPLETER',
      category: 'A-COMPLETER',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: '44-tube-elipse',
      nodeName: '500130',
      label: 'tube elipse',
      reference: '500130',
      category: 'Structure',
      description:
        'Repere 44 de la nomenclature MAVIROLL. Tube elipse. Code article epoxy : ACV003290. Quantite nomenclature : variable.',
      explodeDistance: 1.0,
    },
    {
      id: '500818',
      nodeName: '500818',
      label: '500818',
      reference: 'REF-A-COMPLETER',
      category: 'A-COMPLETER',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: '500819',
      nodeName: '500819',
      label: '500819',
      reference: 'REF-A-COMPLETER',
      category: 'A-COMPLETER',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: '500820',
      nodeName: '500820',
      label: '500820',
      reference: 'REF-A-COMPLETER',
      category: 'A-COMPLETER',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeDistance: 1.0,
    },
    {
      id: 'acv006011-montant-gauche-coulisse-semi-rigide-ma',
      nodeName: 'ACV006011_MONTANT_GAUCHE_COULISSE_SEMI_RIGIDE_MAVIROLL_CONNECT_AD',
      label: 'ACV006011 MONTANT GAUCHE  COULISSE SEMI RIGIDE MAVIROLL CONNECT AD',
      reference: 'REF-A-COMPLETER',
      category: 'Structure',
      description:
        'DESCRIPTION A COMPLETER. Piece presente dans la CAO mais absente de la nomenclature papier fournie (variante MAVIROLL a coulisses souples et entrainement par chaine).',
      explodeVector: [-1, 0, 0],
      explodeDistance: 1.0,
    },
  ],
};
